import React from 'react'
import { Flex, Box, Heading, Text } from 'rebass/styled-components'
import PropTypes from 'prop-types'

import Icomoon from '../Icomoon'

const IconCard = ({ white, type, icon, hideIcon, name, active, description, ...rest }) => {
  return (
    <Box
      active={active}
      {...rest}
      sx={{
        cursor: 'pointer',
        transition: 'opacity 0.363s ease-in-out',

        '&': type === 'product' ? { opacity: active ? 1 : 0.3 } : { opacity: active ? 1 : 0.5 },

        '&:hover': {
          opacity: 1
        }
      }}
    >
      {!hideIcon && (
        <Flex
          alignItems="center"
          justifyContent="center"
          width="60px"
          height="60px"
          mb={6}
          bg="purple2"
          sx={{
            borderRadius: '16px'
          }}
        >
          <Icomoon size="32px" color="white" icon={icon} />
        </Flex>
      )}

      <Heading
        as="h3"
        mb={5}
        variant="level3"
        fontSize="18px"
        fontWeight="700"
        letterSpacing="-0.5px"
        color={white && 'white'}
      >
        {name}
      </Heading>

      <Text as="p" variant="level6" color={white && 'white'}>
        {description}
      </Text>
    </Box>
  )
}

IconCard.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string,
  active: PropTypes.bool,
  hideIcon: PropTypes.bool,
  white: PropTypes.bool,
  description: PropTypes.string
}

export default IconCard
